(ns portfolio.db
  "The single source of truth for the app's mutable state.

  Static page content lives in portfolio.content; runtime state held here:
    :active-section  which page section the user is currently reading
    :lang            current display language (:en or :pt)")

(def default-db
  {:active-section :top
   :lang           :en})
